import { createAPIActions } from '../../lib/redux';

const { fetchResourceDispatcher } = createAPIActions('configuration');

export const fetchConfiguration = fetchResourceDispatcher;
